import React from 'react';
import { useAppUpdate } from '@/hooks/useAppUpdate';
import { Button } from '@/components/ui/button';
import { RefreshCw, Download } from 'lucide-react';

const UpdateNotification = () => {
  const { updateAvailable, isUpdating, triggerUpdate } = useAppUpdate();

  if (!updateAvailable) return null;

  return (
    <div className="fixed bottom-32 right-6 z-[60] left-6 sm:left-auto sm:max-w-sm">
      <div className="glass bg-white/70 border border-white/40 rounded-2xl p-5 shadow-2xl backdrop-blur-3xl">
        <div className="flex items-start space-x-4">
          <div className="flex-shrink-0 w-10 h-10 rounded-full bg-blue-500/10 flex items-center justify-center">
            <Download className="w-5 h-5 text-blue-600" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-bold text-slate-900 font-outfit uppercase tracking-wider">
              Update Available
            </p>
            <p className="text-xs text-slate-600 mt-1 font-medium font-inter">
              A new version is ready with improved performance and UI.
            </p>
          </div>
        </div>
        <div className="mt-4 flex space-x-2">
          <Button
            onClick={triggerUpdate}
            disabled={isUpdating}
            size="sm"
            className="flex-1 rounded-full bg-slate-900 hover:bg-black text-white font-bold h-10 transition-all hover:scale-[1.02]"
          >
            {isUpdating ? (
              <>
                <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
                Updating...
              </>
            ) : (
              'Update Now'
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UpdateNotification; 